"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutNavigation = void 0;
var _navigationContext = require("../../contexts/navigationContext");
var _FormattedMessage = require("../FormattedMessage");
var _NavigationButton = require("./NavigationButton");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const CheckoutNavigation = ({
  stepLabelKey
}) => {
  const {
    navigationButtonsProps,
    selectedStep
  } = (0, _navigationContext.useNavigationContext)();
  const navigationBarOwnerState = {
    selectedStep
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.NavigationBar, {
      ownerState: navigationBarOwnerState,
      children: navigationButtonsProps.map(buttonProps => /*#__PURE__*/(0, _jsxRuntime.jsx)(_NavigationButton.NavigationButton, {
        ...buttonProps
      }, buttonProps.stepNumber))
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Header, {
      variant: "h4",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: stepLabelKey
      })
    })]
  });
};
exports.CheckoutNavigation = CheckoutNavigation;